import React, { createContext, useState } from 'react'

const initialTrack = {
  artist: 'Golden Bug and In Fields',
  id: 'NnlK6XEBG9M9SxPVmwPY',
  image: 'golden-bug-and-in-fields-bones-feat-diego-hdez.jpg',
  name: 'Bones feat. Diego Hdez',
  slug: 'golden-bug-and-in-fields-bones-feat-diego-hdez',
}

const initialQuery = {
  term: null,
  artist: null,
  genre: null,
  vocals: null,
  tempo: null,
  language: null,
}

const initialValue = {
  loop: false,
  setLoop: () => {},
  playerTrack: initialTrack,
  setPlayerTrack: () => {},
  tracks: [],
  filterTracks: () => {},
  query: initialQuery,
  setQuery: () => {},
}

const TrackContext = createContext(initialValue)

function TrackProvider({ children }) {
  const [loop, setLoop] = useState(false)
  const [tracks, filterTracks] = useState([])
  const [playerTrack, setPlayerTrack] = useState(initialTrack)
  const [query, setQuery] = useState(initialQuery)

  return (
    <TrackContext.Provider
      value={{
        setLoop,
        loop,
        playerTrack,
        setPlayerTrack,
        tracks,
        filterTracks,
        query,
        setQuery,
      }}
    >
      {children}
    </TrackContext.Provider>
  )
}

export default TrackContext
export { TrackProvider }
